import { Injectable } from '@angular/core';
import { SharedService } from '../services/shared.service';
import { Location } from '../models/location.model';

@Injectable()
export class SectorHelper {

  constructor(private sharedService: SharedService) {}

  get sectors(): any {
    return this.sharedService.getSectorList();
  }

  get locations(): any {
    return this.sharedService.getLocationList() || [];
  }

  get defaultLocationId(): any {
    const locations = this.locations;
    const defaultLocation = locations.find((loc: Location) => loc.isDefault);
    return defaultLocation ? defaultLocation.locationId : (locations[0]?.locationId || '');
  }

  getSectorColor(sector: string): string {
    let bg: string;
    switch (sector) {
      case 'Štamparija':
        bg = 'blue';
        break;
      case 'Krojačnica':
        bg = 'green';
        break;
      case 'Priprema':
        bg = 'yellow';
        break;
      case 'Šivara':
        bg = 'cyan';
        break;
      case 'Vez':
        bg = 'red';
        break;
      case 'Pletionica':
        bg = 'orange';
        break;
    }

    return bg;
  }

   getSectorColorGraph(sector: string): string {
    let bg: string;
    switch (sector) {
      case 'Štampa':
        bg = '#4A90E2';
        break;
      case 'Krojačnica':
        bg = '#008A6B';
        break;
      case 'Priprema':
        bg = '#DCB000';
        break;
      case 'Šivara':
        bg = '#00FFFF';
        break;
      case 'Vez':
        bg = '#EF4136';
        break;
      case 'Pletionica':
        bg = '#FE6431';
        break;
    }

    return bg;
  }
}
